import { createSlice } from '@reduxjs/toolkit';

export interface GlobalState {
  isMobile: boolean;
  language: string;
  orientation: string;
  breakpoint: string;
}

type BREAKPOINT_TYPE = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

/** ***************** inner Function  ****************** */
const _generateBreakpoint = (): BREAKPOINT_TYPE => {
  if (window.innerWidth >= 1400) return 'xxl';
  if (window.innerWidth >= 1200) return 'xl';
  if (window.innerWidth >= 992) return 'lg';
  if (window.innerWidth >= 768) return 'md';
  if (window.innerWidth >= 576) return 'sm';
  return 'xs';
};

const initialState: GlobalState = {
  isMobile: Boolean(
    navigator.userAgent.match(
      /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
    ),
  ),
  language: navigator.language,
  breakpoint: _generateBreakpoint(),
  orientation: !navigator.maxTouchPoints
    ? 'desktop'
    : !window.orientation
    ? 'portrait'
    : 'landscape',
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {},
});

export const globalActions = globalSlice.actions;
export default globalSlice;
